import Container from "@/components/Container";
import LeadForm from "@/components/LeadForm";

const PARTNER_TYPES = ["investor","estate_agent","sourcing_partner","auction_contact","developer","contractor","finance_partner"];

export default function Investors() {
  return (
    <div className="pt-36 pb-32">
      <Container className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-10">
            <span className="label-mono">No. 07 — Partners</span>
            <span className="h-px w-10 bg-ruby" />
          </div>
          <h1 className="serif-display text-5xl md:text-6xl lg:text-[6.5rem] text-ink-700">
            Build the<br />
            <span className="serif-italic text-ruby">Rubys portfolio</span><br />
            with us.
          </h1>
          <p className="mt-10 text-ink-400 leading-[1.8] text-base lg:text-lg max-w-lg">
            Investors, estate agents, sourcing partners, auction contacts, developers and finance partners — the House is open to the right introductions.
          </p>
        </div>
        <div className="lg:col-span-7">
          <LeadForm
            leadType="investor"
            sourcePage="/investors"
            title="Introduce yourself"
            subtitle="Tell us how you would like to engage. We read every message."
            fields={["name","email","phone","company","message"]}
            extra={[{ name: "partner_role", label: "Role", options: PARTNER_TYPES }]}
            submitLabel="Open the Conversation"
          />
        </div>
      </Container>
    </div>
  );
}
